<template>
  <div class="particularSend cart" :class="cartList.length > 3 ? '' : 'ht'">
    <!-- loading -->
    <van-loading type="spinner" color="rgb(116, 180, 43)" class="loading" v-if="loading" />
    <div class="top_fx">
      <!-- 头部 -->
      <div
        class="cart-header ty-center"
        style="font-size:16px;
      font-family:PingFangSC-Regular,PingFang SC; 
      font-weight:400;
      color:rgba(102,102,102,1);"
      >田野商城</div>
      <!-- 提示 -->
      <div class="ty-center">
        <van-row>
          <van-col span="8">共{{sum}}件商品</van-col>
          <van-col span="16">
            <van-row type="flex" justify="end">
              <van-col span="9" style="position: relative;" @click="clearAll">
                <van-icon name="delete" style="position: absolute;top:10px;left:-15px" />清空购物车
              </van-col>
              <van-col span="8" style="position: relative;" @click="addNewGoods">
                <van-icon
                  name="balance-list-o"
                  style="position: absolute;top: 9.5px;left:-13px"
                  color="rgb(116, 180, 43)"
                />
                <span style="color:rgb(116, 180, 43)">新增商品</span>
              </van-col>
            </van-row>
          </van-col>
        </van-row>
      </div>
    </div>
    <!-- 商品详情 -->
    <div style="position: relative; padding-bottom:110px; padding-top:73px;">
      <van-checkbox-group    v-model="result">
        <div class="goodList"   v-for="index in cartList" :key="index.cartId">
          <!-- <van-checkbox
            :name="index.cartId"
            checked-color="#74B42B"
            v-model="index.isChecked"
            @click="ischeck(index)"
          ></van-checkbox> -->
          <van-checkbox  :name="index.cartId" v-model="index.isChecked"  @click='ischeck(index)' checked-color="#74B42B" ></van-checkbox>
          <div class="ty-top">
            <img
              :src="index.picUrl"
              class="flex_img"
              alt
              style="object-fit: cover;margin-right:5px"
              @click="goDetails(index.goodsId)"
            />
            <p class="text1" @click="goDetails(index.goodsId)">{{index.goodsName}}</p>
            <br />
            <div class="weight">￥{{(index.salePrice/index.saleRatio).toFixed(2)}}/{{index.goodsUnitLabel}}</div>
            <div class="text3">
              <span class="ty-left">
                ￥{{index.salePrice}}/{{index.saleUnitLabel}}
                <span
                  v-if="index.saleRatio != 1 || index.goodsUnitLabel != index.saleUnitLabel"
                >({{index.saleRatio}}{{index.goodsUnitLabel}})</span>
              </span>
              <span class="ty-right">
                <van-stepper
                  class="stepper"
                  button-size="20px"
                  input-width="25px"
                  :min="0"
                  async-change
                  v-model="index.orderQty"
                  :disable-minus="index.orderQty <=0 ? true : false"
                  @overlimit="removeAllGoodsDan(index,index.cartId)"
                  @minus="removeGoodsD(index,index.cartId)"
                  @plus="addGoodsD(index,index.cartId)"
                  @focus="changgeGoods(index,index.cartId)"
                />
              </span>
            </div>
            <!-- 备注 -->
            <div class="remark van-ellipsis" @click="showPop(index.cartId)">备注：{{index.remark}}</div>
            <!-- 备注框 -->
            <van-dialog
              v-model="index.showRemark"
              show-cancel-button
              confirmButtonColor="rgba(116, 180, 43, 1)"
              @confirm="choRemark(index)"
              @cancel="cancelRemark(index)"
            >
              <van-cell-group>
                <van-field
                  v-model="index.remark"
                  rows="1"
                  autosize
                  @input="remarkOd(index.cartId)"
                  type="textarea"
                  maxlength="50"
                  placeholder="请输入备注"
                  show-word-limit
                />
              </van-cell-group>
            </van-dialog>
            <!-- 修改商品数量 -->
            <van-dialog
              confirmButtonColor="rgba(116, 180, 43, 1)"
              v-model="index.showDia"
              title="修改商品数量"
              show-cancel-button
              :beforeClose="chargeBtn"
              @confirm="changgeGoodsNumDan(index)"
            >
              <input
                @change="newOrderChange(index.newOrderQty)"
                type="text"
                v-model="index.newOrderQty"
                class="changeInput"
              />
            </van-dialog>
          </div>
        </div>
      </van-checkbox-group>
        <div v-if='errorTradeCartDTOS.length > 0' class="ty-center" style="margin-top:10px">
        <van-row>
          <van-col span="16">失效商品</van-col>
          <van-col span="7">
            <van-row type="flex"  @click="clearAll" justify="end">
              <van-col span="9" style="position: relative;">
                <van-icon name="delete" style="position: absolute;top:10px;left:-15px" />清空
              </van-col>
            </van-row>
          </van-col>
        </van-row>
      </div>
          <div class="goodList" style="z-index:1"   v-for="index in errorTradeCartDTOS" :key="index.cartId">
           <img  src="../../assets/失效.png"  alt class="invalid" />
          <div class="ty-top cell_cover cell_covercar">
            <img
            class="flex_img"
              :src="index.picUrl"
              alt
              style="object-fit: cover;margin-right:5px"
            />
            <p class="text1">{{index.goodsName || '/'}}</p>
            <br />
            <div class="text3" style="margin-bottom:0px">
              <span  style="color:#999;" class="ty-left">
               商品失效
              </span>
            </div>
          </div>
        </div>
    </div>
    <van-submit-bar
      :disabled='totalPrice == 0'
      :price="totalPrice"
      button-text="下单"
      @submit="onSubmit"
      safe-area-inset-bottom
      button-type="info round"
    >
      <van-checkbox v-model="isCheckAll" checked-color="#74B42B" @click="checkAll">全选</van-checkbox>
    </van-submit-bar>
      <tabbar :activeNew='active' />
    <!-- 导航 -->
    <!-- <van-tabbar
      route
      v-model="active"
      active-color="#74B42B"
      fixed
      style="background: rgba(237, 237, 237, 1);filter:blur(0px);"
    >
      <van-tabbar-item replace to="/index" icon="home-o">主页</van-tabbar-item>
      <van-tabbar-item replace to="/category" icon="apps-o">分类</van-tabbar-item>
      <van-tabbar-item replace to="/cart" icon="cart">购物车</van-tabbar-item>
      <van-tabbar-item replace to="/my" icon="manager-o">我的</van-tabbar-item>
    </van-tabbar> -->
    <div v-if="noSearchList">
      <img  src="../../assets/无订单.png" alt class="noList flex_img " />
      <p class="search-p">暂无商品</p>
    </div>
  </div>
</template>
<script>
import tabbar from "../common/tabbar";
export default {
  components: {
    tabbar
  },
  async created() {
    // 获取购物车列表
    this.getCartLits();
    // 获取客户Id
  },
  data() {
    return {
      loading: true,
      active: 2, //底部导航高亮显示
      isCheckAll: true, // 是否全选
      customerId: "", // 用户id
      cartList: [], // 购物车列表
      showRemark: true, //显示备注框
      noSearchList: false, //没有订单显示图片
      result: [], //全选,
      remarkId: "", //
      children: [], //带到订单确认
      changNum: "",
      errorTradeCartDTOS:[], //失效商品
      // loading: false,
      // finished: false,
      // error: false
    };
  },
  methods: {
    // 全选
    checkAll() {
      //之前代码
      // this.isCheckAll = !this.isCheckAll;
      if (this.isCheckAll) {
        this.children = [...this.cartList];
      } else {
        this.children = [];
      }
      this.isCheckAll
        ? this.cartList.forEach(item => this.result.push(item.cartId))
        : (this.result = []);
      this.cartList.forEach(item => {
        item.isSelected = this.isCheckAll;
      });
    },
    // 异步处理进步器
    onChange() {
      this.$toast.loading({ forbidClick: true });
    },
    // 添加商品方法
    async addGood(Goods) {
      this.GoodsDto = { ...Goods, customerId: this.customerId };
      this.$axios
        .post("/trade/tradeCart/save", this.GoodsDto)
        .then(() => {
          this.state = 0;
        })
        .catch(() => {});
    },
    // 获取购物车列表
    async getCartLits() {
      this.customerId = localStorage.getItem("customerId");
      const res = await this.$axios.get(
        `/trade/tradeCart/allList?customerId=${this.customerId}`
      );
      this.cartList = res.data.data.tradeCartDTOS || [];
      this.errorTradeCartDTOS = res.data.data.errorTradeCartDTOS || [];
      this.loading = false;
      this.cartList.map(index => {
        if (index.remark) {
          this.$set(index, "remark", index.remark);
        } else {
          this.$set(index, "remark", "");
        }
        this.$set(index, "newRemark", index.remark);
        this.$set(index, "isSelected", true);
        this.$set(index, "showRemark", false);
        this.$set(index, "showDia", false);
        this.$set(index, "newOrderQty", index.orderQty);
      });
      localStorage.setItem("CartLits", JSON.stringify(this.cartList));
      this.children = [...this.cartList];
      this.cartList.forEach(item => this.result.push(item.cartId));


      // this.checkAll()
      // 获取购物车总条数
      this.getCartAll();
    },
    // 单选
    ischeck(index) {
      index.isSelected = !index.isSelected;
      if (index.isSelected) {
        // 选择加入
        this.children.unshift(index);
      } else {
        // 不选择删除
        for (var i = 0; i < this.children.length; ) {
          if (index.cartId == this.children[i].cartId) {
            this.children.splice(i, 1);
          } else {
            i++;
          }
        }
      }
      if (!this.cartList.every(item => item.isSelected == true)) {
        this.isCheckAll = false;
      } else {
        this.isCheckAll = true;
        this.cartList.forEach(item => {
          if (this.result.indexOf(item.cartId) == -1) {
            this.result.push(item.cartId);
          }
        });
      }
      //之前代码
      // if (this.cartList.every(item => item.isSelected == true)) {
      //   this.cartList.forEach(item => this.result.push(item.cartId));
      //   this.isCheckAll = true;
      // } else {
      //   this.isCheckAll = false;
      // }
    },
    // 获取订单总数
    async getCartAll() {
      const res = await this.$axios.get(
        `/trade/tradeCart/count?customerId=${this.customerId}`
      );
      this.sum = res.data.data;
    },
    // 清空购物车
    clearAll() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "你确定要清空购物车吗",
          confirmButtonColor: "#74b42b"
        })
        .then(async () => {
          // on confirm
          this.$axios.delete(
            `/trade/tradeCart/delAll?customerId=${this.customerId}`
          );
          const res = await this.$axios.get(
            `/trade/tradeCart/allList?customerId=${this.customerId}`
          );
          this.cartList = res.data.data.tradeCartDTOS || [];
      this.errorTradeCartDTOS = res.data.data.errorTradeCartDTOS || [];
          localStorage.setItem("CartLits", JSON.stringify(this.cartList));
          this.getCartLits();
        })
        .catch(() => {});
    },
    // 提交商品
    onSubmit() {
      // 校验是否是合作客户
      //   /customer/check/customerStage
      this.$dialog
        .confirm({
          title: "提示",
          message: "确认下单？",
          confirmButtonColor: "#74b42b"
        })
        .then(() => {
          this.$axios
            .get(
              `customer/customer/check/customerStage?customerId=${
                this.customerId
              }`
            )
            .then(res => {
              if (res.data.data) {
                this.children = this.children.filter(item => item.orderQty);
                localStorage.setItem("children", JSON.stringify(this.children));
                if (!this.children.length) {
                  return false;
                }
                this.$router.push("/orders");
              }else {
                  this.$toast.fail('您的下单权限未开启，请联系对接人处理。');
              }
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 新增商品
    addNewGoods() {
      this.$router.push({ path: "/classify", query: { categoryId: "1" } });
    },
    onLoad() {
      // this.loading = false;
    },
    // 备注框
    showPop(id) {
      const rs = this.cartList.find(item => {
        return item.cartId == id;
      });
      rs.showRemark = true;
    },
    // 添加备注
    remarkOd() {
      this.state = 0;
    },
    //添加备注
    choRemark(index) {
      if (this.state == 0) {
        this.addGood(index);
      }
    },
    //取消备注
    cancelRemark(index) {
      index.remark = index.newRemark;
    },
    //取消弹框  ---GQ
    // cancelNum(index){
    //   // index.orderQty = index.newOrderQty
    // },
    // 封装方法
    rr_cart(index, id) {
      let cart_index = this.cartList.findIndex(item => item.cartId == id);
      this.cartList.splice(cart_index, 1, index);
      localStorage.setItem("CartLits", JSON.stringify(this.cartList));
    },
    // 移除所有商品
    removeAllGoodsDan(index) {
      index.orderQty = 0;
      this.addGood(index);
    },
    // 减少商品
    removeGoodsD(index, id) {
      if (index.orderQty <= 0) {
        this.$dialog
          .confirm({
            message: "确认删除此商品吗",
            title: "标题",
            confirmButtonColor: "#74b42b"
          })
          .then(async () => {
            // on confirm
            await this.getCartLits();
            this.cartList = this.cartList.filter(item => item.cartId != id);
            this.addGood(index);
          })
          .catch(() => {
            this.getCartLits();
          });
      } else {
        this.addGood(index);
      }
    },
    // 添加商品
    addGoodsD(index) {
      this.addGood(index);
    },
    // 聚焦
    changgeGoods(index) {
      index.newOrderQty = index.orderQty;
      index.showDia = true;
    },
    // 输入单规格
    changgeGoodsNumDan(Goods) {
      if (Goods.newOrderQty <= 0) {
        return;
      }
      Goods.orderQty = Goods.newOrderQty;
      this.addGood(Goods);
    },
    chargeBtn(action, done) {
      if (action == "confirm") {
        if (this.changNum <= 0 || String(this.changNum).length > 3) {
          this.$toast("商品数量必须大于0并且小于四位数");
          return done(false);
        }
        if (String(this.changNum).indexOf(".") == 1) {
          this.$toast("商品数量必须为整数");
          return done(false);
        }
        done(true);
      } else {
        done(true);
      }
      // if (action == "confirm" && this.changNum <= 0) {
      //   this.$toast("商品数量必须大于0");
      //   done(false);
      // } else {
      //   done(true);
      // }
    },
    //
    newOrderChange(num) {
      this.changNum = num;
    },
    // 去商品详情
    goDetails(id) {
      this.$router.push({ path: "/details", query: { goodsId: id } });
    }
  },
  computed: {
    // 合计价格
    totalPrice() {
      return this.cartList.reduce((price, item) => {
        if (item.isSelected) {
          price += item.orderQty * item.salePrice * 100;
        }
        return price;
      }, 0);
    },
    sum: {
      set() {
        return this.cartList.length;
      },
      get() {
        return this.cartList.length;
      }
    }
  },
  watch: {
    cartList: {
      deep: true,
      handler(value) {
        if (value == null) {
          this.noSearchList = true;
        } else if (value.length == 0 && this.errorTradeCartDTOS.length ==0 ) {
          this.noSearchList = true;
        } else {
          //   console.log(value);
          // if (value.length == 0) {
          //   return false;
          // }
          // let flag =value.every(item =>{
          //   console.log(item.orderQty);
          //   return item.orderQty == ''
          // })
          // console.log(flag);
        }
      }
    },
     errorTradeCartDTOS: {
      deep: true,
      handler(value) {
        if (value == null) {
          this.noSearchList = true;
        } else if (value.length == 0 && this.cartList.length == 0) {
          this.noSearchList = true;
        } else {
          //   console.log(value);
          // if (value.length == 0) {
          //   return false;
          // }
          // let flag =value.every(item =>{
          //   console.log(item.orderQty);
          //   return item.orderQty == ''
          // })
          // console.log(flag);
        }
      }
    }
  }
};
</script>

<style lang='scss' scoped>

.top_fx {
  width: 100%;
  position: fixed;
  z-index: 999;
}
.ht {
  height: 100%;
}
.search-p {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
  text-align: center;
}
.cart {
  /* padding-bottom: 250px; */
  background: rgba(242, 242, 242, 1);
  /* height: 100%; */
}
van-checkbox {
  width: 80px;
  background-color: red;
  border: 1px solid rgba(153, 153, 153, 1);
}
.cart-btn {
  background: linear-gradient(
    135deg,
    rgba(172, 219, 86, 1) 0%,
    rgba(116, 180, 43, 1) 100%
  );
  border-radius: 16px;
  border: 0px;
  top: -5px;
}
.ty-top {
  width: 85%;
  position: relative;
  background-color: #fff;
  margin-left: 8%;
  margin-top: 2%;
  border-radius: 10px;
  padding: 10px;
  padding-left: 10px;
  box-shadow: 0px 0px 4px 1px rgba(153, 153, 153, 0.1);
  font-size: 12px;
  overflow: hidden;
}
.sign {
  position: absolute;
  padding-left: 20px;
  box-sizing: border-box;
  right: 0;
  width: 90px;
  height: 24px;
  line-height: 24px;
  background: linear-gradient(
    90deg,
    rgba(116, 180, 43, 0) 0%,
    rgba(116, 180, 43, 0.5) 22%,
    rgba(116, 180, 43, 1) 100%
  );
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  border-radius: 2px;
}
.place1 {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 17px;
}
.place2 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
}
.line {
  width: 100%;
  height: 1px;
  background-color: #dddddd;
  margin: 5px 0;
}
.time1 {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 17px;
}
.time2 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(116, 180, 43, 1);
  line-height: 20px;
}
.ty-center {
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  background: rgba(237, 237, 237, 1);
  padding-left: 20px;
  box-shadow: 0px 0px 1px 1px rgba(221, 221, 221, 0.5);
}
// img:not(.invalid) {
img{
&.flex_img{
  float: left;
  width: 80px;
  height: 88px;
  background: rgba(247, 247, 247, 1);
  border-radius: 2px;
}
 &.noList {
  width: 100% !important;
  height: 200px !important;
}
}
.text1 {
  display: -webkit-box;
  overflow: hidden;
  white-space: normal !important;
  text-overflow: ellipsis;
  word-wrap: break-word;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
}
.text2 {
  font-size: 11px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 16px;
}
.weight {
  width: 68px;
  background: rgba(247, 247, 247, 1);
  border-radius: 2px;
  float: left;
  text-align: center;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 21px;
  border-radius: 10%;
}
.ty-left {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 166, 35, 1);
  line-height: 22px;
}
.ty-right {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
  float: right;
}
.text3 {
  margin: 35px 0 10px;
  padding-left: 80px;
}
.remark {
  margin-top: 50px;
  width: 97%;
  margin: 0 auto;
  background: rgba(102, 102, 102, 0.05);
  border-radius: 8px;
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
  padding-left: 10px;
}
.ty-footer {
  width: 100%;
  height: 49px;
  padding-top: 15px;
  box-sizing: border-box;
  background: rgba(237, 237, 237, 1);
  position: fixed;
  bottom: 50px;
  border-bottom: 1px solid rgba(221, 221, 221, 0.5);
  box-shadow: 0px 0px 1px 1px rgba(221, 221, 221, 0.5);
}
.footer-b {
  padding-left: 8px;
}
.footer-add {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 22px;
}
.footer-add-l,
.footer-add-r {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
}
.footer-add-r {
  color: rgba(244, 166, 35, 1);
}
.footer-war {
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(244, 166, 35, 1);
  line-height: 14px;
}
.van-checkbox__icon .van-icon,
.van-checkbox__icon .van-icon {
  border: 1px solid #000;
}
.van-submit-bar {
  bottom: 50px;
  background-color: rgba(237, 237, 237, 1);
}
.van-submit-bar__bar {
  padding-left: 1%;
  padding-right: 0 !important;
}
.van-submit-bar__button {
  margin-right: 10px !important;
}
.goodList {
  position: relative;
}
.cart /deep/ .van-icon-success {
  border: 1px solid rgba(153, 153, 153, 1);
}
.cart /deep/ .goodList .van-icon-success {
  position: absolute;
  left: 1%;
  top: 50%;
}
.cart /deep/ .goodList .van-checkbox {
  height: 0;
}
.van-submit-bar__button {
  background: linear-gradient(
    135deg,
    rgba(172, 219, 86, 1) 0%,
    rgba(116, 180, 43, 1) 100%
  );
  border: 0px solid #000;
  border-radius: 50px;
  height: 80%;
  line-height: 80%;
  margin-right: 10px;
}

.cart-header {
  height: 40px;
  line-height: 40px;
  /* background: #e7e7e7; */
}
.stepper /deep/ .van-stepper__input {
  -moz-appearance: textfield;
}
.loading {
  position: fixed;
  left: 50%;
  top: 45%;
  transform: translate(-50%, -50%);
}
.stepper /deep/ button {
  background-color: #fff;
  border-radius: 50%;
  color: rgba(116, 180, 43, 1);
}
.stepper /deep/ input {
  background-color: #fff;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
}
</style>